import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminDonationCategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminDonationCategoryModule;